import * as React from "react"
import {List, Stack, Divider} from "@mui/material";

import {AppLink} from "../../../../../@componets";
import MaximalLayoutNavVerticalList from "./NavList";
import MaximalLayoutNavVerticalItem from "./NavItem";


export default function MaximalLayoutNavSectionVertical({ routes, subNav=false, sx={} }) {
    return <Stack sx={{ pt: 1.5 }}>
        { routes.map( ({ path, index, children, ...config }, idx) =>  {
            if (index) return null

            const key= `${path}-${idx}`
            const hasChildren = children && children.filter(item => !item.index).length > 1 && path !== '/'

            if (path === 'divider') {
                return <Divider key={key} sx={{ my: 1, mx: 2 }} />
            }

            return <List key={key} disablePadding sx={{ px: 2 }}>
                { !hasChildren && <AppLink to={path}>
                    <MaximalLayoutNavVerticalItem path={path} isSubItem={subNav} sx={sx} {...config} />
                </AppLink> }

                { hasChildren && <MaximalLayoutNavVerticalList path={path} routes={children} {...config} /> }
            </List>
        }) }
    </Stack>
}